export default __webpack_public_path__ + "static/card0-7c4c98f9b2fbc6abbfe872b623e78ff7.png";